import '@carbon/charts/styles.css';
import { SimpleBarChart, GroupedBarChart, StackedBarChart, PieChart, DonutChart, LineChart, ScatterChart } from '@carbon/charts-react';
import { // Bar
groupedBarOptions, groupedBarData, simpleBarOptions, simpleBarData, simpleBarTimeSeriesOptions, simpleBarTimeSeriesData, stackedBarData, stackedBarOptions, stackedBarTimeSeriesOptions, stackedBarTimeSeriesData // Line
, lineTimeSeriesOptions, lineTimeSeriesData, lineData, lineOptions // Step
, stepOptions, stepData, stepTimeSeriesOptions, stepTimeSeriesData // Scatter
, scatterTimeSeriesOptions, scatterTimeSeriesData, scatterOptions, scatterData // Pie & donut
, pieOptions, pieData, donutOptions, donutData } from "../../../../src/data/charts/index";
import React from 'react';
export default {
  SimpleBarChart,
  GroupedBarChart,
  StackedBarChart,
  PieChart,
  DonutChart,
  LineChart,
  ScatterChart,
  groupedBarOptions,
  groupedBarData,
  simpleBarOptions,
  simpleBarData,
  simpleBarTimeSeriesOptions,
  simpleBarTimeSeriesData,
  stackedBarData,
  stackedBarOptions,
  stackedBarTimeSeriesOptions,
  stackedBarTimeSeriesData,
  lineTimeSeriesOptions,
  lineTimeSeriesData,
  lineData,
  lineOptions,
  stepOptions,
  stepData,
  stepTimeSeriesOptions,
  stepTimeSeriesData,
  scatterTimeSeriesOptions,
  scatterTimeSeriesData,
  scatterOptions,
  scatterData,
  pieOptions,
  pieData,
  donutOptions,
  donutData,
  React
};